import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * LegacyBriefRedirect — retires the standalone staff brief surface.
 *
 * `/my-events` and `/my-events/:eventId` are PERMANENT redirects, not
 * deletions. Both live on outside our control:
 *   • staff_assignment_response.py:319 puts an absolute
 *     FRONTEND_URL/my-events/{id} in every assignment email, so those
 *     links are already sitting in staff inboxes.
 *   • The same URL rides in web-push payloads already delivered to phones.
 *   • staff_assignment_response.py:876 uses it on the public
 *     confirm/decline landing page.
 * Removing the routes would create dead links we cannot recall. They stay.
 *
 * The target carries the event id through untouched. EventBriefDrawer
 * fetches /api/staff/events/{id}/brief by id on its own, and that endpoint
 * accepts BOTH id forms (ObjectId and EVT-xxxx), so a legacy link resolves
 * regardless of which form the original row happened to carry.
 */
export default function LegacyBriefRedirect() {
  const { eventId } = useParams();
  return (
    <Navigate
      to={eventId ? `/staff/my-assignments/${eventId}` : '/staff/my-assignments'}
      replace
    />
  );
}
